import React from 'react';

import SelectField from '../ui/SelectField';
import Body from '../typography/Body';

import StickersheetRow from './StickersheetRow';
import 'react-select/dist/react-select.css';

const styleTitle = {
  marginBottom: 16,
  textTransform: 'capitalize',
};

export default () => (
  <StickersheetRow title="SelectField">
    <Body style={styleTitle}>Default SelectField</Body>
    <SelectField
      name="DefaultSelectField"
      onChange={(selectedOption) => console.log(selectedOption)}
      options={[
        { value: 'one', label: 'One' },
        { value: 'two', label: 'Two' },
      ]}
    />
  </StickersheetRow>
);



// WEBPACK FOOTER //
// ./src/components/demo/SelectFields.js